module.exports = __webpack_public_path__ + "static/img/dummy_burger_thumb_006.3e14c79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/burger/dummy_burger_thumb_006.png
// module id = MRnZ
// module chunks = 1